/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-11-13 15:31
 * @LastEditors: 1544807500@qq.com
 * @LastEditTime: 2025-11-24 09:53
 * @FilePath: \glyun_web_Vue3\src\utils\plugin\initElementPlus.js
 * @Description: xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
 */
import { ElSelect } from 'element-plus'
console.log("🚀 ~ ElSelect:", ElSelect)
// 选择器内容弹框固定下方不变动
ElSelect.props.placement.default = "bottom"
ElSelect.props.popperOptions.default = {
  modifiers: [
    {
      name: 'preventOverflow',
      enabled: false
    }
  ]
}
